import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getNaturezasOperacaoBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("naturezasOperacao/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getNaturezasOperacao(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
                dados.pagina = 1;
                dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("naturezasOperacao/access/listar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    getNaturezaOperacao(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("naturezasOperacao/access/obter", {ID_NATUREZA_OPERACAO: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
	getNaturezaOperacaoSimples(context, idNaturezaOperacao) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("naturezasOperacao/access/obterSimples", {ID_NATUREZA_OPERACAO: idNaturezaOperacao}).then(({ data }) => {
					resolve(data);
				});
			}
		});
	},
    deleteNaturezaOperacao(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("naturezasOperacao/access/excluir", {ID_NATUREZA_OPERACAO: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    postNaturezaOperacao(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("naturezasOperacao/access/salvar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};